module.exports = "<div class=\"pending-delete\">\n  {{pendingDeleteMsg|e}}\n</div>";
